"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.portalsApi = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const chain_adapters_1 = require("@shapeshiftoss/chain-adapters");
const utils_1 = require("@shapeshiftoss/utils");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const viem_1 = require("viem");
const utils_2 = require("../../utils");
const helpers_1 = require("../utils/helpers/helpers");
const constants_1 = require("./constants");
const getPortalsTradeQuote_1 = require("./getPortalsTradeQuote/getPortalsTradeQuote");
const fetchPortalsTradeOrder_1 = require("./utils/fetchPortalsTradeOrder");
exports.portalsApi = {
    getTradeQuote: async (input, { config, assertGetEvmChainAdapter }) => {
        const tradeQuoteResult = await (0, getPortalsTradeQuote_1.getPortalsTradeQuote)(input, assertGetEvmChainAdapter, config);
        return tradeQuoteResult.map(tradeQuote => {
            return [tradeQuote];
        });
    },
    getUnsignedEvmTransaction: async ({ chainId, from, tradeQuote, supportsEIP1559, assertGetEvmChainAdapter, config: swapperConfig, }) => {
        const { affiliateBps, slippageTolerancePercentageDecimal, steps } = tradeQuote;
        const { buyAsset, sellAsset, sellAmountIncludingProtocolFeesCryptoBaseUnit } = steps[0];
        const portalsNetwork = constants_1.chainIdToPortalsNetwork[chainId];
        const sellAssetAddress = (0, helpers_1.isNativeEvmAsset)(sellAsset.assetId)
            ? viem_1.zeroAddress
            : (0, caip_1.fromAssetId)(sellAsset.assetId).assetReference;
        const buyAssetAddress = (0, helpers_1.isNativeEvmAsset)(buyAsset.assetId)
            ? viem_1.zeroAddress
            : (0, caip_1.fromAssetId)(buyAsset.assetId).assetReference;
        const inputToken = `${portalsNetwork}:${sellAssetAddress}`;
        const outputToken = `${portalsNetwork}:${buyAssetAddress}`;
        // Not a decimal percentage, just a good ol' percentage e.g 1 for 1%
        const affiliateBpsPercentage = (0, utils_1.convertBasisPointsToDecimalPercentage)(affiliateBps)
            .times(100)
            .toNumber();
        // We need to re-fetch the quote from Portals here with validation
        // approvals, which prevent quotes during trade input from succeeding if the user hasn't already
        // approved the token they are getting a quote for.
        // TODO: we'll want to let users know if the quoted amounts change much after re-fetching
        const portalsTradeOrderResponse = await (0, fetchPortalsTradeOrder_1.fetchPortalsTradeOrder)({
            sender: from,
            inputToken,
            outputToken,
            inputAmount: sellAmountIncludingProtocolFeesCryptoBaseUnit,
            slippageTolerancePercentage: Number(slippageTolerancePercentageDecimal) * 100,
            partner: (0, helpers_1.getTreasuryAddressFromChainId)(sellAsset.chainId),
            feePercentage: affiliateBpsPercentage,
            validate: true,
            swapperConfig,
        });
        if (!portalsTradeOrderResponse.tx)
            throw new Error('Portals Tx simulation failed upstream');
        const { value, to, data, 
        // Portals has a 15% buffer on gas estimations, which may or may not turn out to be more reliable than our "pure" simulations
        gasLimit: estimatedGas, } = portalsTradeOrderResponse.tx;
        const { gasLimit, ...feeData } = await chain_adapters_1.evm.getFees({
            adapter: assertGetEvmChainAdapter(chainId),
            data,
            to,
            value,
            from,
            supportsEIP1559,
        });
        return {
            to,
            from,
            value,
            data,
            chainId: Number((0, caip_1.fromChainId)(chainId).chainReference),
            // Use the higher amount of the node or the API, as the node doesn't always provide enought gas padding for
            // total gas used.
            gasLimit: bignumber_js_1.default.max(gasLimit, estimatedGas).toFixed(),
            ...feeData,
        };
    },
    checkTradeStatus: utils_2.checkEvmSwapStatus,
};
